

























import { Component, Vue } from 'vue-property-decorator'

import { authService } from '@/services'
import { modules } from '@/store'
import { authRoutesNames } from '@/pages/auth/auth.routes'

import AuthCard from '@/pages/auth/components/AuthCard.vue'

@Component({
  name: 'Login',
  components: {
    AuthCard
  }
})
export default class Login extends Vue {
  routeNames = authRoutesNames
  /* C O M P U T E D */
  get loading () {
    return modules.general.loading
  }

  /* M E T H O D S */
  login () {
    authService.login()
  }
}
